<ng-container *ngIf="loading">
  <div class="mdc-layout-grid__inner full-height" *ngIf="global">
    <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
      <div class="loading-img-container">
        <div class="custom-loading-spinner"></div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="!global">
    <div class="full-height" *ngIf="!dotted">
      <div class="loading-img-container">
        <div class="custom-loading-spinner"></div>
      </div>
    </div>
    <div class="dotted-loader" *ngIf="dotted ">
      <span></span><span></span><span></span>
    </div>
  </ng-container>
</ng-container>
